// extracted by mini-css-extract-plugin
export var actionButton = "modal-module--action-button--1b609";
export var buttonContent = "modal-module--button-content--c21cc";
export var buttonIcon = "modal-module--button-icon--20618";
export var clone = "modal-module--clone--c436c";
export var header = "modal-module--header--697d7";
export var modal = "modal-module--modal--705fd";
export var subTitle = "modal-module--sub-title--453d6";
export var title = "modal-module--title--8150a";